import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;

const Panel = styled.div`
  width: min(480px, 100%);
  max-height: min(80vh, 640px);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(
    145deg,
    ${props => props.$primary || "#1F3B6F"},
    ${props => props.$secondary || "#4CAF50"}
  );
  color: #fff;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
`;

const CloseButton = styled.button`
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
`;

const Body = styled.div`
  padding: 18px 20px 22px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-word;
`;

export default function ReceiptPrivacyModal({
  open,
  title = "Privacy Policy",
  content,
  primaryColor,
  secondaryColor,
  onClose
}) {
  if (!open || !content) return null;

  return (
    <Overlay onClick={onClose} role="presentation">
      <Panel onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        <Header $primary={primaryColor} $secondary={secondaryColor}>
          <Title>{title}</Title>
          <CloseButton type="button" onClick={onClose} aria-label="Close">
            ×
          </CloseButton>
        </Header>
        <Body>{content}</Body>
      </Panel>
    </Overlay>
  );
}
